var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchpatientActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32432 2.19985H10.5135C11.8271 2.19985 12.8919 3.27437 12.8919 4.59985V9.40002C12.8919 12.7137 10.2298 15.4 6.94595 15.4M4.56757 2.19985H3.37838C2.06484 2.19985 1 3.27436 1 4.59985V9.40001C1 12.7137 3.66209 15.4 6.94595 15.4M6.94595 15.4V18.4C6.94595 22.0451 9.87425 25 13.4865 25C17.0987 25 20.027 22.0451 20.027 18.4V17.2M20.027 17.2C21.669 17.2 23 15.8569 23 14.2C23 12.5432 21.669 11.2 20.027 11.2C18.3851 11.2 17.0541 12.5432 17.0541 14.2C17.0541 15.8569 18.3851 17.2 20.027 17.2ZM9.32432 1L9.32429 3.39976M4.56757 1.00002V3.40002",
    stroke: "#0D45DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchpatientActive);
export default __webpack_public_path__ + "static/media/searchpatient_active.13e85d5fe070b5ce014934fe9f7e30df.svg";
export { ForwardRef as ReactComponent };